import React, {useState, useRef, useEffect} from 'react';
import {observer} from 'mobx-react-lite';
import {Modal, Button} from '@/components/common-components/components';
import styles from './index.module.scss';
import styled from 'styled-components';
// import {Alert} from 'antd';
import {Input} from '@/components/common-components/v2';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCaretDown} from '@fortawesome/pro-solid-svg-icons';
import {faFileArrowUp} from '@fortawesome/pro-light-svg-icons';
import {keywordNewLineReg} from '@/constants/regex';
// import {keywordListValidation, validationErrorMessage} from '@/utils/validations/keyword';
import {stringToArray} from '@/utils/arrays';
import {useStore} from '@/store/root-store';
// import {CustomTextarea} from '@/components/common-components/components/form/input/customTextarea';
import {KeCountrySelectV2} from '../ke-common-components-v2/keCountrySelect';
import {QuotaInfoDetail} from '@/components/common-components/v2/quotaInfo';
import {notification} from '@/utils/notification';
import {toJS} from 'mobx';
import {CustomTextarea} from '@/components/common-components/components/form/input/customTextarea';

interface Props {
  title?: string;
  isRecord?: any;
  buttonName?: string;
  setListName?: (value)=>void;
  listName?: string;
  newKeyword?:any;
  setNewKeyword?: (value)=>void;
  setSelectedCountry?:(value)=>void;
  selectedCountry?: any;
  isKMTPage?: boolean;
  loadPageData?: (value: any, value2: string | null) => void;
}
export const CreateList: React.FC<Props> = observer(({loadPageData, isKMTPage=false, title, isRecord, buttonName, setListName, listName, newKeyword, setNewKeyword, setSelectedCountry, selectedCountry}) => {
  const [isEmptyInput, setIsEmptyInput] = useState(false);
  const [keywordCount, setKeywordCount] = useState(0);
  const [loader, setLoader] = useState(false);
  const [isValidKeyword, setIsValidKeyword] = useState(false);
  const regex = /^[^a-zA-Z0-9]+$/;
  const {
    countries: {getSpecificCountryByCode},
    contentOptimizer: {
      currentPage,
    }} = useStore('');
  const {settings: {customer: {isGHLAccount}}} = useStore('');
  const {keywordResearcherV2: {
    keywordDetails: {createList, setCreateListModalData},
  }} = useStore('');
  const hiddenFileInput = useRef(null);
  const formattedSelectValue = selectedCountry?.locationId ? {
    ...selectedCountry,
    location: selectedCountry?.location ? selectedCountry.location : (selectedCountry?.countryCode ? getSpecificCountryByCode(selectedCountry.countryCode?.toUpperCase())?.name : ''),
  } : {
    ...toJS(createList)?.selectedCountry,
    location: toJS(createList)?.selectedCountry?.location ? toJS(createList)?.selectedCountry.location : (toJS(createList)?.selectedCountry?.countryCode ? getSpecificCountryByCode(toJS(createList)?.selectedCountry.countryCode?.toUpperCase())?.name : ''),
  };
  const getLocationStr = async () => {
    const locationStr = await currentPage?.getCountryData(selectedCountry?.locationId ? selectedCountry?.locationId : toJS(createList)?.selectedCountry?.locationId);
    const updatedData = {
      ...formattedSelectValue,
      location: locationStr?.location || '',
    };
    setSelectedCountry(updatedData);
  };
  const {settings: {customer: {getCustomerQuota, profile: {quotaUtilization, isWhitelabel}}}} = useStore('');
  const {plans: {showSidebarPaymentDrawer}} = useStore('');
  const [defaultLocations] = useState([
    {
      countryCode: 'US',
      location: 'United States',
      locationId: 2840,
    },
    {
      countryCode: 'CA',
      location: 'Canada',
      locationId: 2124,
    },
    {
      countryCode: 'AU',
      location: 'Australia',
      locationId: 2036,
    },
    {
      countryCode: 'GB',
      location: 'United Kingdom',
      locationId: 2826,
    },
    {
      countryCode: 'DE',
      location: 'Germany',
      locationId: 2276,
    },
  ]);
  const {
    keywordResearcherV2: {postNewKeywords, loadKeyWordsList, setKeyWordListDetail, updatedKeywordListData, isOpenModal, setIsOpenModal},
  } = useStore('');
  useEffect(() => {
    if ((selectedCountry?.locationId || toJS(createList)?.selectedCountry?.locationId) && isOpenModal) {
      getLocationStr();
    }
  }, [isOpenModal]);
  useEffect(() => {
    const count = newKeyword?.split('\n').filter(keyword => keyword !== '').length || 0;
    if (count > 0) {
      setKeywordCount(count);
    } else {
      setKeywordCount(0);
    }
  }, [newKeyword]);

  const handleKeywords = value=>{
    if (value) setIsEmptyInput(false);
    if (!regex.test(value)) setIsValidKeyword(false);
    setNewKeyword(value);
  };

  const handleListName = value =>{
    setListName(value);
  };

  const onChange= value => {
    setCreateListModalData({
      selectedCountry: value,
    });
    setSelectedCountry(value);
  };
  const handleClick = () => {
    hiddenFileInput?.current?.click();
  };
  const handleChange = async e =>{
    e.preventDefault();
    if (e?.target?.files[0]?.type == 'text/plain' || e?.target?.files[0]?.type == 'text/csv') {
      const reader = new FileReader();
      reader.onload = async e => {
        const text = (e?.target?.result);
        setIsEmptyInput(false);
        setNewKeyword(text);
      };
      reader?.readAsText(e?.target?.files[0]);
    } else {
      notification.error('Invalid file type', 'Please upload a file of type .csv or .txt', false, 'OK');
    }
  };

  // const checkRestrictedKw = keywordList => {
  //   const check = [];
  //   keywordList?.map(item => {
  //     if (item == 'cbd' || item == 'tobacco' || item == 'guns' || item == 'gun' || item == 'firearms' || item?.includes('cbd ') || item?.includes(' cbd') || item?.includes('tobacco ') || item?.includes(' tobacco') || item == 'link building') {
  //       check?.push(item);
  //     }
  //   });
  //   return check;
  // };
  const closeModal = () => {
    setIsEmptyInput(false);
    setIsValidKeyword(false);
    setIsOpenModal(false);
  };
  const isQuotaremaining = quotaUtilization?.ke?.maxKeywordLookups?.consumed >= quotaUtilization?.ke?.maxKeywordLookups?.total;
  const handleSubmit = async () => {
    if (isQuotaremaining) {
      if (isWhitelabel) {
        if (isGHLAccount) {
          notification.error('', "You've reached the limit to optimize this page. Need more? Reach out to our support team for help!");
        } else {
          notification.error('Quota is exceeded', 'You’ve exceeded the usage limit for this tool.');
        }
      } else {
        showSidebarPaymentDrawer();
      }
    } else {
      if (newKeyword?.trim()?.length === 0 || newKeyword==='//') {
        setIsEmptyInput(true);
        setIsValidKeyword(false);
        return;
      }
      if (regex.test(newKeyword)) {
        setIsValidKeyword(true);
        setIsEmptyInput(false);
        return;
      }
      setLoader(true);
      let updatedKeywordList = stringToArray(newKeyword, keywordNewLineReg, ',');
      // const getRestricted = checkRestrictedKw(updatedKeywordList);
      const data = {'name': listName, 'keywords': updatedKeywordList, 'is_recent_search': false};
      const checkFromDefault = defaultLocations?.find(item => item.locationId == selectedCountry.locationId);
      if (checkFromDefault?.locationId) {
        data['country_code'] = checkFromDefault?.countryCode || '';
        data['location_id'] = checkFromDefault?.locationId || '';
        data['country_name'] = checkFromDefault?.location || '';
        // data['location_id'] = null;
      } else if (selectedCountry?.locationId || selectedCountry?.countryCode) {
        data['location_id'] = selectedCountry?.locationId || null;
        data['country_code'] = selectedCountry?.countryCode || '';
        data['country_name'] = selectedCountry?.location || '';
      } else {
        data['country_code'] = selectedCountry?.countryCode || '';
        data['location_id'] = null;
        data['country_name'] = '';
      }
      if (buttonName== 'Update List') {
        const res = await updatedKeywordListData(data, isRecord?.id);
        if (isKMTPage) {
          loadPageData(data, res?.name);
        }
      } else {
        const response = await postNewKeywords(data);
        getCustomerQuota();
        if (response) {
          try {
            loadKeyWordsList(false);
            setKeyWordListDetail();
          } catch (error) {
            notification.error('', 'Failed to load keywords');
          }
        } else {
          setLoader(false);
        }
      }
      updatedKeywordList = updatedKeywordList?.map(keyword => {
        return keyword.replaceAll(' ', '+');
      });
      setLoader(false);
      closeModal();
    }
  };
  return (
    <>
      <StyledModal
        onClose={() => closeModal()}
        visible={isOpenModal}
        destroyOnClose={true}
        className={styles.customKeywordModal}>
        <div className={styles.modalContent}>
          <h3>{title}</h3>
          <FlexWrapper style={{flexWrap: 'wrap', gap: '10px'}}>
            <div style={{display: 'flex', flexDirection: 'column', flexGrow: '1'}}>
              <InputHeading>List name</InputHeading>
              <InputWrapper
                onChange={e=>handleListName(e?.target?.value)}
                value={listName}
              ></InputWrapper></div>
            <div style={{display: 'flex', flexDirection: 'column'}}>
              <InputHeading style={{marginLeft: '6px'}}>Location</InputHeading>
              <KeCountrySelectV2
                variant='lightGray'
                dropdownStyle={{backgroundColor: '#2D2F34', color: '#fff', marginLeft: '17px', width: '30px'}}
                suffixIcon={<FontAwesomeIcon color='#fff' icon={faCaretDown}/>}
                showSearch
                selectValue={formattedSelectValue}
                className={'selectInput'}
                onChange={onChange}
              /></div>
          </FlexWrapper>
          <KeywordWrapper>Keywords</KeywordWrapper>
          <CustomTextarea isKeyWordv2={false} variant='light' placeholder={'Enter one or more keywords separated by a new line (Shift + Enter)'} value={newKeyword} onChange={e => handleKeywords(e.target?.value)}></CustomTextarea>
          {isEmptyInput && <p style={{color: '#ff4d4f', textAlign: 'left', left: '10%'}}>Enter one or more keywords</p>}
          {isValidKeyword && <p style={{color: '#ff4d4f', textAlign: 'left', left: '10%'}}>Only special characters are not allowed</p>}
          {/* {!findKeyword && newKeyword?.replace('/', ',')?.trim() != '' ? <WrapperAlert message={`${validationErrorMessage}`} description={ <ul>{formatKeywordError(errorKeywordList)} </ul>} type='error' /> : ''} */}

          <div style={{display: 'flex', paddingTop: '10px', justifyContent: 'space-between', alignItems: 'center', whiteSpace: 'nowrap', flexWrap: 'wrap'}}>
            <div>
              <FontAwesomeIcon style={{color: '#2D6CCA', fontSize: '16px', paddingTop: '3px', paddingRight: '8px'}} icon={faFileArrowUp}/>
              <a style={{color: '#2D6CCA'}} onClick={handleClick}>
                Import from file
              </a>
            </div>
            {keywordCount> 0 && <span style={{color: '#4E5156', fontSize: '12px', font: 'Inter', lineHeight: '14.52px'}}>
              Creating this list costs {`${keywordCount}`} quota point{`${keywordCount > 1 ? 's' : ''}`}
            </span>}
          </div>
          <input type='file'
            ref={hiddenFileInput}
            accept='.csv,.txt'
            onChange={e=>handleChange(e)}
            style={{display: 'none'}}
          />
          <div className={styles.modalFooter}>
            <div>
              <QuotaInfoDetail consumedData={quotaUtilization?.ke?.maxKeywordLookups?.consumed} totalData= {quotaUtilization?.ke?.maxKeywordLookups?.total} heading={'Keywords'} description={'Total number of keywords'} isCenter={true}/>
            </div>
            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-end'}}>
              <CancelButton
                onClick={()=> closeModal()}
                size='lg'>
                Cancel
              </CancelButton>
              <Button
                style={{background: '#FF8536', whiteSpace: 'nowrap'}}
                buttonType='success'
                onClick={handleSubmit}
                loading={loader}
                disabled={loader}
                size='lg'>
                {buttonName}
              </Button>
            </div>
          </div>
        </div>
      </StyledModal>
    </>
  );
});
const FlexWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;
const CancelButton = styled(Button)`
  background: #FFFFFF;
  border: 1px solid #E8E8E8;
  border-radius: 5px;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: #4E5156;
  margin-right: 10px;
`;
// const WrapperAlert = styled(Alert)`
//  width: 500px;
// `;
const InputHeading = styled.div`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  color: #4E5156;
  padding-bottom: 4px;
`;

const KeywordWrapper= styled.div`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  color: #4E5156;
  padding-top: 20px;
  padding-bottom: 4px;
  
`;

const InputWrapper = styled(Input)`
  background: #F9F9FB !important;
  border: 1px solid #E8E8E8 !important;
  border-radius: 5px !important;
`;

const StyledModal = styled(Modal)`
  @media screen and (max-width: 650px) {
    width: 75% !important;
    .rc-dialog-body {
      padding: 15px;
    }
  }
`;
